import { Info } from "lucide-react";

const FallbackEmailNotice = () => (
    <div className="flex min-w-0 items-start gap-1.5 text-xs text-emerald-700 sm:items-center">
        <Info size={14} className="mt-0.5 shrink-0 sm:mt-0" aria-hidden="true" />
        <span className="leading-4">
            <span className="font-semibold">Fallback email</span>
            <span className="ml-1">
                — OptiMind generates and delivers a personalized version of
                this email to each lead.
            </span>
        </span>
    </div>
);

export default FallbackEmailNotice;
